export function setDateAndTime(dateAndTime) {
  return {
    type: 'SET_TIME',
    payload: dateAndTime,
  }
}
